<template lang="pug">
.intro-yezza
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-text.pa-5
        .h6.basic800--text.text-center Setup your online store
        .h6.basic800--text.text-center in 9 minutes
        v-layout.my-8(style="height:275px; overflow: hidden;")
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/intro_yezza.gif')" width="275" contain)
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_expense.png')")
          v-col
            .s1.primary500--text Online store 
            .c1.basic600--text Promote your link & get online orders via Yezza Store or WhatsApp form.
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_manage.png')")
          v-col
            .s1.primary500--text Yezza Pay
            .c1.basic600--text Payment gateway with 1-minute setup and RM 1.00 transaction fee.
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_manage.png')")
          v-col
            .s1.primary500--text Inventory management
            .c1.basic600--text Manage stocks efficiently. Avoid overbooking.
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_income.png')")
          v-col
            .s1.primary500--text Order management
            .c1.basic600--text Systematic order management. Integrated with parcel delivery and rider.

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-medium.primary400--text Cancel
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='clickStartTrial')
          .button-AA-small.basic100--text Start 14-day trial
</template>

<script>
export default {
  name: "YezzaIntroModal",
  props: ['company', 'open'],
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    clickStartTrial () {
      this.$emit('try')
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>